import { ScrapingTemplateCardProps } from '@/decodo/blocks/ScrapingTemplateLibrary/Components/ScrapingTemplateCard';
import {
  SCRAPING_CARD_DATA_TRACKER_COMPONENT,
  SCRAPING_TEMPLATE_LIBRARY_NUMBER_OF_ROWS,
} from '@/decodo/blocks/ScrapingTemplateLibrary/consts';
import { useScreenSize } from '@smartproxy-web/shared/hooks';
import { useEffect, useRef, useState } from 'react';

export function getTagsForCards(
  cards: { attributes: ScrapingTemplateCardProps }[]
) {
  return cards.reduce((acc, currentVal) => {
    const associatedTags = currentVal.attributes.scraping_template_tags.data;
    if (!associatedTags?.length) return acc;

    const currentCardTags: string[] = associatedTags.map((tag) => {
      return tag.attributes.title;
    });

    currentCardTags.forEach((tag) => {
      if (!acc.includes(tag)) {
        acc.push(tag);
      }
    });

    return acc;
  }, [] as string[]);
}

export const useScrapingTemplateLibraryGridContainerHeight = ({
  nbCards,
}: {
  nbCards: number;
}) => {
  const { isDesktop, isMobile, isTablet } = useScreenSize();
  const [maxHeight, setMaxHeight] = useState(0);
  const cardContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!cardContainerRef.current) return;

    let cardsPerRow = 1; // mobile
    if (isTablet) cardsPerRow = 2;
    if (isDesktop) cardsPerRow = 3;

    const cards = cardContainerRef.current.querySelectorAll(
      `[data-tracker-component=${SCRAPING_CARD_DATA_TRACKER_COMPONENT}]`
    );
    let totalHeight = 0;

    for (
      let i = 0;
      i < SCRAPING_TEMPLATE_LIBRARY_NUMBER_OF_ROWS * cardsPerRow;
      i += cardsPerRow
    ) {
      if (!cards[i]) break;

      totalHeight += cards[i].clientHeight;
    }

    // accomodate gap-6 of the grid + a 0.5x sized gap for the shadow to appear before the cutoff
    const maxH =
      totalHeight + 24 * (SCRAPING_TEMPLATE_LIBRARY_NUMBER_OF_ROWS - 0.5);
    setMaxHeight(maxH);
  }, [isDesktop, isMobile, isTablet, nbCards]);

  return {
    cardContainerRef,
    maxHeight,
  };
};
